import onSelectionChange from '../events/onSelectionChange';
import setFocusedRowKey from '../internal/mutators/setFocusedRowKey';
import setSelectionAnchorRowKey from '../internal/mutators/setSelectionAnchorRowKey';
import setMultiSelectionAnchorRowKey from '../internal/mutators/setMultiSelectionAnchorRowKey';
import resetSelectionInternal from '../internal/resetSelectionInternal';
import * as mailListSelectionActions from 'owa-mail-actions';
import { orchestrator } from 'satcheljs';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
/////////////////////////////////////// PLEASE READ ///////////////////////////////////////////////////////////
// This is a top level selection action, as such, it should never call other top-level selection
// actions in the same directory, but only call into internal subdirectories where the core logic is implemented.
// This prevents double logging for CTQs as well as prevents onSelectionChange from being fired multiple times
// for a single user action.
///////////////////////////////////////////////////////////////////////////////////////////////////////////////
/**
 * Resets selection in the given table
 * @param tableView where the reset is requested
 * @param mailListItemSelectionSource The source of selection on mail item
 */
export default orchestrator(mailListSelectionActions.resetSelection, function (actionMessage) {
    var tableView = actionMessage.tableView;
    var mailListItemSelectionSource = actionMessage.mailListItemSelectionSource;
    resetSelectionInternal(tableView);
    // Clear selection anchor on if user's doing a clear selection as a top level action
    if (isMailFeatureEnabled('tri-selectionRefactor')) {
        setSelectionAnchorRowKey(tableView, tableView.focusedRowKey);
        setMultiSelectionAnchorRowKey(tableView, null);
    }
    else {
        setFocusedRowKey(tableView, null);
    }
    // Propagate selection change event
    onSelectionChange(tableView, false /* isUserNavigation */, mailListItemSelectionSource);
});
//# sourceMappingURL=resetSelectionOrchestrator.js.map